import { ClinicConfig, EInvoiceConfig, MedicalFacilityConfigRequest, PrescriptionAPIConfig } from '../../types';
import { delay } from '../mock/delay';
import { mockClinicConfig, mockPrescriptionAPIConfig } from '../mock/config';
import { AxiosResponse } from 'axios';
import apiClient from '../api/client';

export const configService = {
  getClinicConfig: async (): Promise<ClinicConfig> => {
    await delay(300);
    return mockClinicConfig;
  },

  saveMedicalFacilityConfig: async (config: MedicalFacilityConfigRequest): Promise<AxiosResponse<any>> => {
    return apiClient.put<MedicalFacilityConfigRequest, AxiosResponse>('/medical-facilities/config/national-rx/', config);
  },

  saveEInvoiceConfig: async (config: EInvoiceConfig): Promise<AxiosResponse<any>> => {
    return apiClient.put<EInvoiceConfig, AxiosResponse>('/medical-facilities/config/einvoice/', config);
  },

  getPrescriptionAPIConfig: async (): Promise<PrescriptionAPIConfig> => {
    await delay(300);
    return mockPrescriptionAPIConfig;
  },

  getMedicalFacilityConfig: async (): Promise<AxiosResponse<{success: boolean, data: MedicalFacilityConfigRequest}>> => {
    return apiClient.get('/medical-facilities/config/national-rx/');
  },

  getEInvoiceConfig: async (type: 'pharmacy' | 'medical_facility'): Promise<AxiosResponse<{success: boolean, data: EInvoiceConfig}>> => {
    return apiClient.get('/medical-facilities/config/einvoice/?type=' + type);
  },

  savePrescriptionAPIConfig: async (config: PrescriptionAPIConfig): Promise<void> => {
    await delay(800);
    Object.assign(mockPrescriptionAPIConfig, config);
  },
};

